import React, { useEffect, useState } from "react";
import MainSlider from "../../components/mainSlider/MainSlider";
import PredictionTabs from "../../components/predictionSection/PredictionTabs";
import PredictTabs from "../../components/predictTabs/PredictTabs";
import PrizeSlider from "../../components/prizeSlider/PrizeSlider";
import BottomBar from "../../layouts/bottomBar/BottomBar";
import Navbar from "../../layouts/navbar/Navbar";
import EditIcon from "../../assets/icon/Edit.svg";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import Select from "react-select";

import {
  checkUser,
  countryCodes, userDetails,
  userProfileUpdate,
} from "../../services/MainApiDetails";
import LanguageSwitch from "../settings/components/LanguageSwitch";
import {User} from "../../actions";
import {useDispatch} from "react-redux";
import { ERROR } from "../../utilities/colors";
import GoldenBallPromo from "../profile/components/goldenBallPromo/GoldenBallPromo";
// import MobileUserStat from './components/mobileUserStat/MobileUserStat'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const MobileHome = () => {
  const [verifiedUser, setVerifiedUser] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openAddress, setAddressOpen] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [language, setLanguage] = React.useState("en");
  const [options, setOptions] = useState();
  const [selectedOption, setSelectedOption] = useState({
    value: "",
    label: "Please choose country",
  });
  const [countryCode, setCountryCode] = useState("");
  const [address, setAddress] = useState("");
  const [errorAddress, setErrorAddress] = useState("");
  const [errorCountry, setErrorCountry] = useState("");
  const [errorPostalCode, setErrorPostalCode] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [state, setState] = useState("");
  const [defaultDialCode, setDefaultDialCode] = useState("+91");

  const [userPhone, setUserPhone] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [errors, setErrors] = useState({
    phone: "",
    email: "",
    name: "",
  });
  const dispatch = useDispatch();

  const [openLanguageSwitch, setOpenLanguageSwitch] = useState(true);

  const handleLanguageSwitchOpen = () => {
    setOpenLanguageSwitch(true);
  };

  const handleLanguageSwitchClose = () => {
    setOpenLanguageSwitch(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleAddressClickOpen = () => {
    setAddressOpen(true);
  };

  const handleAddressClose = () => {
    setAddressOpen(false);
  };
  function changeLanguages() {
    localStorage.setItem("language", language);
    window.location.reload();
  }
  function setUserLanguage(e, value) {
    e.className = "switch-btn-selected";
    setLanguage(value);
  }
  useEffect(() => {

    if (localStorage.is_mobile && verifiedUser == false) {
      checkUserStatus();
    }
  }, [verifiedUser == false]);
  useEffect(() => {
    if (localStorage.webKey) {
      getUserDetails()
    }
  },[])
  function checkUserStatus() {
    checkUser({})
      .then((res) => {
        if (res.data.status == 105) {
          setAddressOpen(true);
          getCountryCodes();
        } else {
          setVerifiedUser(true);
          if (localStorage.is_mobile && localStorage.language == undefined) {
            setOpen(true);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  function getUserDetails() {
    // if ((userProfile.length ==0)  && localStorage.webKey) {
    userDetails().then((response) => {
      if (response.data.status === 1) {
        dispatch(User(response.data.user_data));
      }
    });

    // console.log(userProfile)
  }
  function getCountryCodes() {
    countryCodes({})
      .then((res) => {
        if (res.data.status === 1) {
          setCountryCode(res.data.result);
          let countryDetails = res.data.result;
          settingCountry(countryDetails);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }
  function validatePhone() {
    var validation = false;

    let regex = /^(\+?[0-9]{2})?([0-9]{10})$/;
    validation = regex.test(userPhone);

    return validation;
  }

  function validateEmail() {
    var validation = false;

    let regex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    validation = regex.test(userEmail);

    return validation;
  }
  function settingCountry(county_details) {
    let optionData = [];
    county_details.map((item) => {
      optionData.push({ value: item.name, label: item.name });
    });
    setOptions(optionData);
    setSelectedOption({ value: "", label: "Please choose country" });
  }
  function countryCodeFunction(item) {
    let cCode = countryCode.filter((single) => single.dial_code === item);
    setDefaultDialCode(cCode[0].dial_code);
  }
  function CountryNameSeting(e) {
    setCountryCode(e.value);
  }
  function createAddress() {
    var message = [];

    if (
      userPhone === "" ||
      !validatePhone() ||
      userPhone.length < 8 ||
      userPhone.length > 12
    ) {
      message.phone = "Invalid phone number";
      setErrors(message);
    }

    if (userEmail && !validateEmail()) {
      message.email = "Invalid email address";
      setErrors(message);
    } else {
      let email = userEmail;
      userProfileUpdate({
        phone: userPhone,
        pf_key:1,
        country_code: defaultDialCode,
        email: userEmail,
        address: address,
        zip_code: postalCode,
        state: state,
        country: countryCode,
      })
        .then((res) => {
          if (res.data.status) {
            setVerifiedUser(true);
            alert("Address updated successfully");
            setAddressOpen(false);
            if (localStorage.is_mobile && !localStorage.language) {
              setOpen(true);
            }
          } else {
            alert(res.data.message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  // Language Switching
  function changeLanguage(value) {
    localStorage.setItem("language", value);
    window.location.reload();
    // setOpenLanguageSwitch(false);
  }
  return (
    <div className="mobileHome">
      <div className="container-fluid">
        <div className="row">
          {/* <MainSlider /> */}
          {/* <MobileUserStat /> */}
          {/* <PredictTabs /> */}
          <PredictionTabs />
        </div>
      </div>
      <div className="editNameModal">
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="editNameModal-wrapper">
            <div className="editNameModal-closeIcon">
              <CloseIcon className="closeIcon" onClick={handleClose} />
            </div>
            <div className="editNameModal-header">
              <h2>Switch Language</h2>
            </div>
            <div className="editNameModal-form-wrapper">
              <div className="mobileSettings-languageSwitch-wrapper">
                <p className="switch-text">Switch your questions language</p>
                <div className="language-switchBtn-wrapper">
                  <button
                    className={
                      language != "en" ? "switch-btn-selected" : "switch-btn"
                    }
                    onClick={(e) => setUserLanguage(e, "ml")}
                  >
                    MALAYALAM
                  </button>
                  <button
                    className={
                      language == "en" ? "switch-btn-selected" : "switch-btn"
                    }
                    onClick={(e) => setUserLanguage(e, "en")}
                  >
                    ENGLISH
                  </button>
                </div>
              </div>
            </div>
            <div className="editNameModal-button-wrapper">
              <Button
                type="button"
                className="editNameModal-login-btn"
                onClick={changeLanguages}
              >
                CONFIRM
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="editAddressModal">
        <Dialog
          open={openAddress}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleAddressClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="editNameModal-wrapper">
            <div className="editNameModal-closeIcon">
              <CloseIcon className="closeIcon" onClick={handleAddressClose} />
            </div>
            <div className="editNameModal-header">
              <h2>Update your profile</h2>
            </div>
            <div className="editNameModal-form-wrapper">
              <form action="">
                <div className="editNameModal-input-wrapper">
                  <div className="editNameModal-inputBox">
                    <span>Mobile Number</span>
                    <div className="mobileRegister-phoneInput-container">
                      <select
                        onChange={(e) => countryCodeFunction(e.target.value)}
                        name="country-code"
                        id="country-code"
                      >
                        {countryCode
                          ? countryCode.map((item) => (
                              <option
                                key={item._id}
                                value={item.dial_code}
                                selected={
                                  item.dial_code == defaultDialCode
                                    ? "selected"
                                    : ""
                                }
                              >
                                {item.dial_code}
                              </option>
                            ))
                          : ""}
                      </select>
                      <input
                        type="number"
                        placeholder="Type here"
                        value={userPhone}
                        onChange={(e) => setUserPhone(e.target.value)}
                      />
                    </div>

                    <span className="mandatory-text">
                      You cant change mobile number in future
                    </span>
                    {/* <span>{errors.phone}</span> */}
                  </div>
                  <div className="editNameModal-inputBox">
                    <span>Email ID</span>
                    <input
                      type="text"
                      placeholder="Type here"
                      value={userEmail}
                      onChange={(e) => setUserEmail(e.target.value)}
                    />
                    <span className="mandatory-text">
                      You cant change email id in future
                    </span>
                    <span>{errors.email}</span>
                  </div>

                  <div className="editNameModal-inputBox">
                    <span>Address</span>
                    <textarea
                      placeholder="Type here"
                      onChange={(e) => setAddress(e.target.value)}
                    ></textarea>
                    <span style={{ color: ERROR }}>{errorAddress}</span>
                  </div>
                  <div className="editNameModal-inputBox">
                    <span>Postal code</span>
                    <input
                      type="text"
                      placeholder="Type here"
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                    <span style={{ color: ERROR }}>{errorPostalCode}</span>
                  </div>
                  <div className="editNameModal-inputBox">
                    <span>State</span>
                    <input
                      type="text"
                      onChange={(e) => setState(e.target.value)}
                      placeholder="Type here"
                    />
                  </div>
                  <div className="editNameModal-inputBox">
                    <span>Country</span>
                    <Select
                      defaultValue={selectedOption}
                      onChange={(e) => CountryNameSeting(e)}
                      placeholder="Select your country"
                      options={options}
                      menuPlacement="top"
                      className="select-option"
                    />
                    <span style={{ color: ERROR }}>{errorCountry}</span>
                  </div>
                </div>
              </form>
            </div>
            <div className="editNameModal-button-wrapper">
              <Button
                type="button"
                onClick={() => createAddress()}
                className="editNameModal-login-btn"
              >
                CONFIRM
              </Button>
            </div>
          </div>
        </Dialog>
      </div>

      {/* Language Switch Modal */}

      {console.log(localStorage.language)}

      {!localStorage.webKey && !localStorage.language ? (
        <div className="pleaseLoginModal">
          <Dialog
            open={openLanguageSwitch}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleLanguageSwitchClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <div className="pleaseLoginModal-wrapper">
              <div className="pleaseLoginModal-header">
                <h2>Select Language</h2>
              </div>
              {/* <div className="pleaseLoginModal-content">
          <p>Please login to start predicting.</p>
        </div> */}
              <div className="laguageSwitch-wrapper">
                <LanguageSwitch changeLanguage={changeLanguage} />
              </div>
              <div className="pleaseLoginModal-button-wrapper">
                <Button
                  onClick={handleLanguageSwitchClose}
                  className="pleaseLoginModal-login-btn"
                >
                  CLOSE
                </Button>
              </div>
            </div>
          </Dialog>
        </div>
      ) : (
        ""
      )}

      {/* Language Switch Modal */}
    </div>
  );
};

export default MobileHome;
